import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import TransactionsTable from './TransactionsTable';
import styles from './styles/transactionHistorySection.module.scss';

/**
 * Pure presentational composition of the Transaction History area.
 * Receives the props directly from
 * `transactions.getViewProps()`:
 *
 *   - `rows` — array of transaction objects for the active page
 *   - `loading` — boolean
 *   - `pageInfo` — `{ current, perPage, total }` consumed by the package Table
 *   - `onChange` — antd Table change handler the package forwards back
 */
function TransactionHistorySection({ rows, loading, pageInfo, onChange }) {
    return (
        <section className={styles.section}>
            <Text as="p" size="l" className={styles.sectionLabel}>Transaction History</Text>
            <TransactionsTable
                rows={rows}
                loading={loading}
                pageInfo={pageInfo}
                onChange={onChange}
            />
        </section>
    );
}

export default TransactionHistorySection;
